import { CLIENT_ID, CLIENT_ID_MOBILE, CLIENT_SK, CLIENT_VER } from '../config/global';
import { useUserStore } from '../store/modules/user';
import { getIam, request } from '../utils/request';
import { rsaEncByPublic } from '../utils/sec';
import { encodeBase58, encodePass, isMiniProgram } from '../utils/tools';

function getClientId() {
  return isMiniProgram() > 0 ? CLIENT_ID_MOBILE : CLIENT_ID;
}

//微服务自动登录(因为所有api都是需要鉴权的，所以至少要先自动获取一个游客token)
export async function srvAutoLogin(orgid:string, ctxt:string){
  //携带orgid。会随机一个用户Name，然后一个注册邮箱，生成一个token
  //此时获取不到微服务，只能由用户输入或提前判断
  //可以直接这样自动登录获取临时token
  return request.post({
    url: `/${ctxt}/tuser/autologin`,
    method: 'post',
    params: { project:orgid }
  });
}


//调用微服务发送邮件编码
export async function srvSendMailCode(orgid:string, email:string, op:string, ctxt:string){
  const iam = getIam();
  //已经改为使用iam发送。实测，有的微服务器发送不出去email
  return request.post({
    url: `${iam}sms/smscode`,
    method: 'post',
    //email小写，
    params: { email, op }
  });

  /*//需要email及orgid
  return request.post({
    url: `/${ctxt}/tuser/smscode`,
    method: 'post',
    //email大写
    params: { orgid, Email:email, op }
  });*/
}

//调用微服务注册接口
export async function srvRegisterByMailCode(orgid:string, LoginName:string, UserName:String,
  Password:string,  EmailCode:string,  ctxt:string){
  //需要email及orgid。密码要加密
  return request.post({
    url: `/${ctxt}/tuser/register`,
    method: 'post',
    //直接获取token，避免再次登录
    params: { orgid, LoginName, UserName, Password:encodePass(Password), EmailCode, token:true}
  });
}

//调用微服务注册接口
export async function srvModPwdByMailCode(orgid:string, LoginName:string,
  NewPass:string,  EmailCode:string,  ctxt:string){
  //需要email及orgid。密码要加密
  return request.post({
    url: `/${ctxt}/tuser/cpwdemail`,
    method: 'post',
    //直接获取token，避免再次登录
    params: { orgid, LoginName, NewPass:encodePass(NewPass), EmailCode, token:true }
  });
}

//调用微服务注册接口
export async function srvLogin(orgid:string, Name:string, Pass:String,
  ctxt:string){
  //需要email及orgid。密码要加密
  return request.post({
    url: `/${ctxt}/tuser/login`,
    method: 'post',
    //直接获取token，避免再次登录
    params: { orgid, Name, Pass:encodePass(Pass) }
  });
}

function obfuscate(data, key = 0xAA): Uint8Array {
  return data.map(b => b ^ key);
}

export async function webLoginSend(data) {
  const iam = getIam();
  const param = {
    loginType: 'account',
    user: data.account, // 服务端配置的登录方式为userid，则将账号作为userid去检查。因此客户端显示时账号此时就要显示为userid
    pwd: encodePass(data.password), // pwd的生成需要在客户端先经过用户的RSA公钥加密，产生的byte数组通过base64编码而得到。
    ctxt: data.ctxt,//要登录的系统（从服务端的配置获取--不同的域名不同的系统上下文，对于单域名多系统的，为null）
    clientId: data.clientId?data.clientId:getClientId(),
    clientSecret: CLIENT_SK,
    clientVer: CLIENT_VER
  };
  if (data.captcha){
    param['captcha'] = data.captcha;
  }
  if (data.track){//压缩过
    param['data'] = encodeBase58(obfuscate(data.track));
  }
  let lurl = `${iam}oauth/login`;
  if(data['orgid']){
    lurl = `${iam}oauth/login?orgid=${data['orgid']}`;
  }
  return request.post({
    url: lurl,
    method: 'post',
    params: param
  });
}

export async function externalLoginSend(data) {
  const iam = getIam();
  const param = {
    user: data.account, // 服务端配置的登录方式为userid，则将账号作为userid去检查。因此客户端显示时账号此时就要显示为userid
    pwd: encodePass(data.password),
    params: data.params,
    loginType: 'account',
    // 如果手动传入clientId则用传入的，目前合宙登陆使用
    clientId: data.clientId?data.clientId:getClientId(),
    clientSecret: CLIENT_SK,
    clientVer: CLIENT_VER,
    orgid: data.orgid
  };

  if(data.track){
    param['data'] = encodeBase58(obfuscate(data.track));
  }

  if (data.captcha){
    param['captcha'] = data.captcha;
  }
  let lurl = `${iam}externaluser/login`;
  return request.post({
    url: lurl,
    method: 'post',
    params: param
  // },{apiUrl:"http://localhost:20014"});
  });
}

export async function userLoginSend(ctxt:string, data:any) {
  const param = {
    loginType: 'account',
    user: data.account, // 服务端配置的登录方式为userid，则将账号作为userid去检查。因此客户端显示时账号此时就要显示为userid
    pwd: encodePass(data.password), // pwd的生成需要在客户端先经过用户的RSA公钥加密，产生的byte数组通过base64编码而得到。
    clientId: getClientId(),
    clientSecret: CLIENT_SK,
    clientVer: CLIENT_VER
  };
  //直接到微服务的登录，nginx会自动路由
  let lurl = `/${ctxt}/tuser/web/login`;
  return request.post({
    url: lurl,
    method: 'post',
    params: param
  });
}

// 游客登录
export async function loginGust(data) {
  const iam = getIam();
  const param = {
    loginType: 'account',
    user: data.account, // 服务端配置的登录方式为userid，则将账号作为userid去检查。因此客户端显示时账号此时就要显示为userid
    // pwd: encodePass(data.password), // pwd的生成需要在客户端先经过用户的RSA公钥加密，产生的byte数组通过base64编码而得到。
    ctxt: data.ctxt,
    clientId: getClientId(),
    clientSecret: CLIENT_SK,
    clientVer: CLIENT_VER
  };
  if (data.track){
    param['data'] = data.track;
  }
  let lurl = `${iam}oauth/guest_login_by_account`;
  if(data['orgid']){
    lurl = `${iam}oauth/guest_login_by_account?orgid=${data['orgid']}`;
  }
  return request.post({
    url: lurl,
    method: 'post',
    params: param
  });
}

//游客自动登录论坛(因为所有api都是需要鉴权的，所以至少要先自动获取一个游客token)
export async function autologinGust(data) {
  const iam = getIam();
  const param = {
    loginType: 'account',
    user: data.account, // 服务端配置的登录方式为userid，则将账号作为userid去检查。因此客户端显示时账号此时就要显示为userid
    // pwd: encodePass(data.password), // pwd的生成需要在客户端先经过用户的RSA公钥加密，产生的byte数组通过base64编码而得到。
    clientId: getClientId(),
    clientSecret: CLIENT_SK,
    clientVer: CLIENT_VER
  };
  let lurl = `${iam}oauth/guest_login_by_account`;
  if(data['orgid']){
    lurl = `${iam}oauth/guest_login_by_account?orgid=${data['orgid']}`;
  }
  return request.post({
    url: lurl,
    method: 'post',
    params: param
  });
}

// 系统所有资源
export function loginAllRes(innerName) {
  /**
请求时前端生成一个AES密钥，然后使用RSA公钥加密这个Key。作为请求参数(menukey)带上
服务端收到后使用RSA私钥解密获取AESkey,然后使用AES加密后压缩传回去。
前端再解压，然后Aes解密就可以获取结果了。
   */
  const iam = getIam();
  const userStore = useUserStore();
  let ak = userStore.aesKey;
  let baseskey: any = rsaEncByPublic(ak);
  const par = {
    menukey: baseskey,
    base: ['userid', 'wno', 'sex', 'realname', 'shownname', 'shownava', 'grp', 'email', 'mobile'], // 基础。固定，如果不要sex则不带，整个base也可以不带
    more: ['nickname', 'nickava', 'realava', 'idcard', 'birthday', 'addrnow', 'email2', 'email3', 'mobile2', 'mobile3'], // 更多。固定
    arcs: [], // 部门
    myarcs: '', // 部门
    rools: '', // 角色
    sids: '', // 业务列表
    menus: 0, // 菜单列表:返回该用户所有的菜单系统
    // menu: '435345', // '0', // '435345', // 返回指定指定系统的所有菜单
    apis: '', // api接口，暂时不用
    ddids: [1, 2, 3], // 需要使用的枚举值
    dxids: [0], // 需要使用的复杂枚举值
    settings: [], // 个人配置
    darcs: [], // 不用
    drools: '', // 不用
    slogan: '2' // 请求返回的条数
  };
  return request.post({
    url: `${iam}upms/res/get/tree`,
    method: 'post',
    params: par
  });
}

// export const urlUserGetall = `${iam}user/getall`;
export function getUserList() {
  const iam = getIam();
  return request.post({
    url: `${iam}user/getall`,
    data: {
      fields: [
        'userid',
        'tp',
        'wno',
        'sex',
        'realname',
        'shownname',
        'shownava',
        'grp',
        'email',
        'mobile',
        'nickname',
        'nickava',
        'realava',
        'cvava',
        'idcard',
        'birthday',
        'addrnow',
        'email2',
        'email3',
        'mobile2',
        'mobile3'
      ],
      unids: [],
      containArc: true
    }
  });
}
export function getUserByuid() {
  const iam = getIam();
  const userStore = useUserStore();
  const unid = userStore.unid;
  return request.post({
    url: `${iam}user/getall`,
    data: {
      "unids":[unid],
      "fields":["userid", "wno","sex","realname","shownname","shownava","email","mobile","nickname"]
      }
  });
}


export function updateUserInfo(par) {
  const iam = getIam();
  return request.post({
    url: `${iam}user/selfupdate`,
    data: par
  });
}

export function updateUserPass(par) {
  const iam = getIam();
  return request.post({
    url: `${iam}user/changepwd`,
    data: par
  });
}

export function orgIdByHostSend(host: string){
  const iam = getIam();
  return request.post({
    url: `${iam}get_params_by_host`,
    data: {
      host,
    },
  });
}

export function getSetByKey(key: string) {
  const iam = getIam();
  return request.post({
    url: `${iam}setst/getkey`,
    data: {
      k: key
    }
  });
}


export function iamGetCaptcha(user: string) {
  const iam = getIam();
  return request.post({
    url: `${iam}oauth/get_captcha`,
    data: {
       user: user
    }
  });
}

// export function logout() {
//   return request({
//     url: '/oauth/logout',
//     method: 'post',
//   })
// }

// export function register() {
//   return request({
//     url: '/register',
//     method: 'post',
//   })
// }

export function openmenus(orgid: string,ctxt: string) {
  const iam = getIam();
  return request.post({
    url: `${iam}upms/menusps/openmenus`,
    data: { orgid, ctxt }
  });
}